module.exports = __webpack_public_path__ + "static/media/discover-incentives.8ce01774.svg";